import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    rowGap: theme.spacings.sm,
    marginBottom: theme.spacings.md,
    borderRadius: theme.borderRadii.md,
  },
  title: {
    fontSize: theme.fontSizes.xl,
    fontWeight: '600',
    color: theme.colors.black,
  },
  contentWrapper: {
    width: '100%',
  },
  contentText: {
    fontSize: theme.fontSizes.lg,
    color: theme.colors.black,
  },
});
